import { RendererBaseProps } from '../index';
import { ImagePage } from './image-page';

export const ImageRenderer = ({
  docId,
  getPageDimensions,
  visiblePages,
  getPagePosition,
  highlights,
  highlightedFactId,
  onHighlightClick,
  highlightedChunkId,
  totalHeight,
  isSelectionMode,
  onSelectionComplete,
  maintainSelection,
  activeSelection,
}: RendererBaseProps) => {
  return (
    <div className="relative w-full bg-gray-100" style={{ height: totalHeight }}>
      {visiblePages.map((pageNumber) => {
        const pageDims = getPageDimensions(pageNumber);

        return (
          <ImagePage
            key={pageNumber}
            pageNumber={pageNumber}
            top={getPagePosition(pageNumber)}
            dimensions={{ height: pageDims.height, width: pageDims.width }}
            highlights={highlights}
            highlightedFactId={highlightedFactId}
            onHighlightClick={onHighlightClick}
            highlightedChunkId={highlightedChunkId}
            docId={docId}
            isSelectionMode={isSelectionMode}
            onSelectionComplete={onSelectionComplete}
            maintainSelection={maintainSelection}
            activeSelection={activeSelection}
          />
        );
      })}
    </div>
  );
};
